export const DEFAULT_PUBLIC_ROUTE = '/sign-in';
export const DEFAULT_PRIVATE_ROUTE = '/matchbet/banking';
